// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn__3UlhP","btnText":"btnText__3vV2T","btnImg":"btnImg__3-24n","controlBtn":"controlBtn__W7AiZ","lineThrough":"lineThrough__BZDEL","btnArea":"btnArea__3rlk-"};


//////////////////
// WEBPACK FOOTER
// ./components/communication/call-btn/style.scss
// module id = c5PF
// module chunks = 27